/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react'
import { Button, ButtonGroup, Icon } from 'semantic-ui-react'
import { Link } from 'react-router-dom-v5-compat'
import { useTranslation } from 'react-i18next'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { acceptOrder } from '../../../services/Order/Order.service'

const OrderFlowActions = ({order}) => {
    const [t] = useTranslation()
    const queryClient = useQueryClient()

    const acceptOrderMutation = useMutation({
        mutationFn: () => acceptOrder(order),
        onMutate: () => {
            queryClient.setQueryData(['orders', 'current'], (oldCurrent) => {
                const orderIndex = oldCurrent.findIndex((o) => o.id === order.id)
                if (orderIndex !== -1) {
                    return [
                        ...oldCurrent.slice(0, orderIndex),
                        {...oldCurrent[orderIndex], status: 'ACCEPTED'},
                        ...oldCurrent.slice(orderIndex + 1),
                    ]
                }
                return oldCurrent
            })
        },
        onSuccess: async () => {
            await queryClient.invalidateQueries({
                queryKey: ['orders', 'current'],
            })
        },
    })

    return (
      <ButtonGroup widths={2}>
          <Button
            basic={['RECEIVED', 'DENIED', 'EXPIRED', 'COMPLETED'].includes(order.status)}
            as={Link}
            color='teal'
            to={`/orders/${order.id}`}
            css={css`
                &.ui.button {
                    display: grid;
                    grid-template-areas: "left center right";
                }
            `}
          >
              <span
                css={css`
                    grid-area: center;
                `}
              >
                  {['RECEIVED', 'DENIED', 'EXPIRED', 'COMPLETED'].includes(order.status) ?
                    t('order.see') :
                    t('order.notification.handle')}
              </span>

              {!['RECEIVED', 'DENIED', 'EXPIRED', 'COMPLETED'].includes(order.status) &&
                <Icon
                  css={css`
                      grid-area: right;
                      justify-self: right;
                  `}
                  name="right chevron"
                />
              }
          </Button>
          {order.status === 'RECEIVED' &&
            <Button
              color="green"
              loading={acceptOrderMutation.isPending}
              onClick={acceptOrderMutation.mutate}
            >
                {t('order.accept')}
            </Button>
          }
      </ButtonGroup>
    )
}

export { OrderFlowActions }
